import './sliderMenu.css';
import { useEffect } from 'react';
import { NavLink } from "react-router-dom";
import BlueBox from "../BlueBox";
import { CSSTransition } from 'react-transition-group';

const SliderMenu = (props) => {

const body = document.getElementById('root');

useEffect (() => {
    if(props.isOn) {
        body.classList.toggle('scroll_blocked');
    }
}, [props.isOn])


    return(
        <CSSTransition in={props.isOn} timeout={400} classNames='sliderMenu' mountOnEnter unmountOnExit>
        <article className='sliderMenu'>
            <ul role="navigation">
                <li onClick={props.onTrigger}><NavLink aria-label="Home" to='home' className='sliderLink'>Home</NavLink></li>
                <li onClick={props.onTrigger}><NavLink aria-label="Bio" to='bio' className='sliderLink'>Bio</NavLink></li>
                <li onClick={props.onTrigger}><NavLink aria-label="Concerts" to='concerts' className='sliderLink'>Concerts</NavLink ></li>
                <li onClick={props.onTrigger}><NavLink aria-label="Media" to='media' className='sliderLink'>Media</NavLink ></li>
             </ul>
        </article>
        </CSSTransition>

    )
}

export default SliderMenu;